import english from './en.json';
import german from './de.json';

export type ClinicalTranslator = (key: string, values?: Record<string, unknown>) => string;
function translator(messages: unknown): ClinicalTranslator {
  return (key, values = {}) => {
    let value: unknown = messages;
    for (const part of key.replace(/^clinicalTrials\./, '').split('.')) {
      value = value && typeof value === 'object' ? (value as Record<string, unknown>)[part] : null;
    }
    return (typeof value === 'string' ? value : key).replace(
      /\{\{(\w+)\}\}/g,
      (match, name: string) => String(values[name] ?? match)
    );
  };
}
export const defaultClinicalText = translator(english);
export const defaultPosterText = translator(german);
